import React from 'react';

import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { getDateTime } from '../helpers';
import { getMoney } from '../helpers';
import { getValue } from '../helpers';
import { PAGE_MENU, PAGINATION, STYLES } from '../../constants';
import API from '../../services/api';
import ButtonSort from '../custom/buttonsort';
import CustomAlert from '../custom/alert';
import CustomPaper from '../custom/paper';
import CustomPopover from '../custom/popover';
import CustomTablePagination from '../custom/tablepagination';
import FilterLogDialog from '../filterlogdialog';
import Title from '../title';
import Subtitle from '../subtitle';

export default function ComponentDepositolog({ children, ...props }) {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [row, setRow] = React.useState(null);
  const [alert, setAlert] = React.useState({ open: false, message: '' });
  const [pagination, setPagination] = React.useState({ perPage: PAGINATION.PER_PAGE });
  const [query, setQuery] = React.useState(null);
  const [reload, setReload] = React.useState(false);
  const [sortConfig, setSortConfig] = React.useState({ asc: true, id: '', keys: [] });
  const [state, setState] = React.useState({ data: [], lastPage: 1, page: 1, perPage: 20, total: 0 });
  const load = React.useRef(true);

  const profile_id = Number(API.encryptedSessionStorage.getItem('profile_id', API.encryptedSessionStorage.getTokenData().uid));
  const classe_ids = JSON.parse(API.encryptedSessionStorage.getItem('classe_ids', API.encryptedSessionStorage.getTokenData().uid));

  const params = ((profile_id === 1) ? { state_id: 1 } : { classe_ids: classe_ids });

  function componentDidMount() {
    if (load.current) {
      API.Depositos.index({ ...pagination, ...query, ...params }).then(onSuccess).catch(onFailure);
    }
    return function componentWillUnmount() { load.current = false; };
  }

  function onPaginationChanged() {
    API.Depositos.index({ ...pagination, ...query, ...params }).then(onSuccess).catch(onFailure);
    return function paginationChanged() { };
  }

  function onReloadChanged() {
    if (reload) {
      API.Depositos.index({ ...query, ...params, perPage: pagination.perPage, page: 1 }).then(onSuccess).catch(onFailure);
    }
    return function reloadChanged() { setReload(false); };
  }

  function onFilterChanged() {
    API.Depositos.index({ ...query, ...params, perPage: pagination.perPage, page: 1 }).then(onSuccess).catch(onFailure);
    return function filterChanged() { };
  }

  React.useEffect(componentDidMount, []);
  React.useEffect(onPaginationChanged, [pagination]);
  React.useEffect(onReloadChanged, [reload]);
  React.useEffect(onFilterChanged, [query]);

  function onSuccess(response) {
    if (load.current && response.data) {
      setState(response.data);
    }
  }

  function onFailure(error) {
    if (load.current && error) {
      setAlert({ open: true, message: error.message });
    }
  }

  function onChangeStateSuccess(response) {
    if (load.current && response.data) {
      setReload(true);
    }
  }

  const handlePopoverOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setRow(item);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setRow(null);
  };

  function handleChangePagination(newPagination) {
    setPagination({ ...pagination, ...newPagination });
  }

  function handleApprove(event, item) {
    event.preventDefault();
    API.Depositos.update(item.id, { state_id: 2 }).then(onChangeStateSuccess).catch(onFailure);
  }

  function handleDisapprove(event, item) {
    event.preventDefault();
    API.Depositos.update(item.id, { state_id: 3 }).then(onChangeStateSuccess).catch(onFailure);
  }

  return (
    <>
      <FilterLogDialog
        title={'Filtrar validações'}
        setFilter={setQuery}
        filter={query}
        show_to_account={true}
        show_owner_email={true}
        show_owner_name={true}
      />

      <CustomPopover
        open={Boolean(anchorEl)}
        item={anchorEl}
        onClose={handlePopoverClose}
        data={row}
      >
      </CustomPopover>

      <CustomPaper>
        <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })} >{alert.message}</CustomAlert>
        <Grid container spacing={1}>
          <Grid item >
            <Title><AttachMoneyIcon /></Title>
          </Grid>
          <Grid item >
            <Title>{PAGE_MENU.VALIDACOES}</Title>
          </Grid>
        </Grid>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="inherit">
                <ButtonSort
                  id={'description'}
                  keys={['description']}
                  config={sortConfig}
                  setConfig={setSortConfig}
                  state={state}
                  setState={setState}
                >
                  {'Motivo'}
                </ButtonSort>
              </TableCell>
              <TableCell align="inherit">
                <ButtonSort
                  id={'owners_email'}
                  keys={['owners_email']}
                  config={sortConfig}
                  setConfig={setSortConfig}
                  state={state}
                  setState={setState}
                >
                  {'Responsável'}
                </ButtonSort>
              </TableCell>
              <TableCell align="inherit">
                <ButtonSort
                  id={'to_account_name'}
                  keys={['to_account.name']}
                  config={sortConfig}
                  setConfig={setSortConfig}
                  state={state}
                  setState={setState}
                >
                  {'Beneficiário'}
                </ButtonSort>
              </TableCell>
              <TableCell align="inherit">
                <ButtonSort
                  id={'valor'}
                  keys={['valor']}
                  config={sortConfig}
                  setConfig={setSortConfig}
                  state={state}
                  setState={setState}
                >
                  {'Valor'}
                </ButtonSort>
              </TableCell>
              <TableCell align="inherit">
                <ButtonSort
                  id={'logtime'}
                  keys={['logtime']}
                  config={sortConfig}
                  setConfig={setSortConfig}
                  state={state}
                  setState={setState}
                >
                  {'Data e Hora'}
                </ButtonSort>
              </TableCell>
              { profile_id === 2 &&
              <TableCell align="inherit">
                <ButtonSort
                  id={'state_name'}
                  keys={['state.name']}
                  config={sortConfig}
                  setConfig={setSortConfig}
                  state={state}
                  setState={setState}
                >
                  {'Situação'}
                </ButtonSort>
              </TableCell>
              }
              { profile_id === 1 &&
              <>
              <TableCell align="center"><Subtitle>{'Aprovar'}</Subtitle></TableCell>
              <TableCell align="center"><Subtitle>{'Reprovar'}</Subtitle></TableCell>
              </>
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {state.data
              .map((item) => (
                <TableRow key={item.id}>
                  <TableCell align="inherit" onMouseEnter={(e) => handlePopoverOpen(e, item)} onMouseLeave={handlePopoverClose}>{getValue(item, 'description', '')}</TableCell>
                  <TableCell align="inherit" onMouseEnter={(e) => handlePopoverOpen(e, item)} onMouseLeave={handlePopoverClose}>{getValue(item, 'owners_email', '')}</TableCell>
                  <TableCell align="inherit" onMouseEnter={(e) => handlePopoverOpen(e, item)} onMouseLeave={handlePopoverClose}>{getValue(item, 'to_account_name', '')}</TableCell>
                  <TableCell align="inherit" style={STYLES.MONEY.POSITIVE}>{getMoney(item, ['valor'])}</TableCell>
                  <TableCell align="inherit" >{getDateTime(item, 'logtime', '')}</TableCell>
                  { profile_id === 2 &&
                  <TableCell align="inherit">{getValue(item, 'state.name', '')}</TableCell>
                  }
                  { profile_id === 1 &&
                  <>
                  <TableCell align="center"><IconButton size="small" onClick={((e) => handleApprove(e, item))}><CheckCircleIcon color='primary' /></IconButton></TableCell>
                  <TableCell align="center"><IconButton size="small" onClick={((e) => handleDisapprove(e, item))}><RemoveCircleIcon /></IconButton></TableCell>
                  </>
                  }
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <CustomTablePagination page={state.page - 1 | 0} count={state.total} onChange={handleChangePagination} />
      </CustomPaper >
    </>
  );
}
